<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white"> Bank Details</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);"> Bank Details</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="student-scholarship ptb--100 ">
  <div class="container">
    <div class="table-responsive">
      <table class="table table-border table-hover table-striped table-effect--primary ">
        <thead>
          <tr>
            <th>Bank Name</th>
            <th>Account No.</th>
            <th>IFSC code</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ICIC BANK</td>
            <td>624205021153</td>
            <td>ICIC0006242</td>

          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
